module.exports = __webpack_public_path__ + "img/19.eaec4a26.jpg";